<template>
  <div>
    <Tag v-for="(tag, i) in item.tags" :key="`${tag.value}${i}`">
      {{ tag.text }}
    </Tag>
  </div>
</template>
<script>
import props from './props'
export default {
  name: 'form-item-tag',
  mixins: [props],
  data () {
    return {}
  }
}
</script>